export default __webpack_public_path__ + "static/media/boton-libros.54a53038.png";